import {
  Button,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
} from "@mui/material";
import "./dataMapTable.scss";
import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import Buttons from "../../Controls/Buttons/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormHelperText from "@mui/material/FormHelperText";
import TextField from "@mui/material/TextField";
import { useDispatch, useSelector } from "react-redux";
import { getSheetsNames } from "../../../redux/pre_processor/actions";
import CloseIcon from "@mui/icons-material/Close";

const ParameterNameInput = ({
  newParameterIndex,
  newParameter,
  handleNewParameterNameChange,
  validation,
}) => {
  const [value, setValue] = useState(newParameter?.parameter);

  const onChange = (value) => {
    setValue(value);
  };
  return (
    <div className="cell-outer">
      <TextField
        id="outlined-basic"
        variant="outlined"
        placeholder="Parameter"
        value={value}
        onChange={(e) => onChange(e.target.value, newParameterIndex)}
        onBlur={(e) => handleNewParameterNameChange(value, newParameterIndex)}
      />
    </div>
  );
};

const NewParameter = ({ role, handleAddParameter }) => {
  const [newParameters, setNewParameters] = useState([]);
  const [newParameterCount, setNewParameterCount] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [validation, setValidation] = useState({
    isError: false,
    message: "",
  });

  const sheetNames = useSelector((state) => state?.prePro?.sheetNames);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!openModal) {
      setNewParameters([]);
      setNewParameterCount("");
      setOpenModal(false);
    }
  }, [openModal]);
  const handleAdNewParameterChange = (value) => {
    // setNewParameterCount(value);
    const trimmedValue = value.replace(/^0+/, "");

    if (/^-?\d*$/.test(trimmedValue) && trimmedValue.length <= 3) {
      setNewParameterCount(value);
    }
  };

  // below logic for new parametersData

  const addNewParameterClick = () => {
    dispatch(getSheetsNames(localStorage.projectId));
    const parametersToAdd = [];
    for (let i = 0; i < newParameterCount; i++) {
      parametersToAdd.push({
        parameter: "",
        sheetName: "",
      });
    }
    setNewParameters([...newParameters, ...parametersToAdd]);
    setNewParameterCount("");
  };

  const handleNewParameterNameChange = (value, index) => {
    newParameters[index].parameter = value;
    setNewParameters(newParameters);
    setValidation({ ...validation, isError: false, message: "" });
  };

  const handleDeleteParameter = (newParameterIndex) => {
    newParameters.splice(newParameterIndex, 1);
    setNewParameters([...newParameters]);
  };

  const onHandleChangeNewParameterSheetName = (value, newParameterIndex) => {
    newParameters[newParameterIndex].sheetName = value;
    setNewParameters([...newParameters]);
    setValidation({ ...validation, isError: false, message: "" });
  };

  const onClickAddParameterButton = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
    setValidation({ isError: false, message: "" });
  };

  const onClickAddParameter = (newParameters) => {
    // Check if there are duplicates in parameter names
    const hasDuplicates = (arr) =>
      new Set(arr.map((param) => param.parameter)).size !== arr.length;

    const isParameterEmpty = (parameter) => parameter.parameter !== "";
    const isSheetNameEmpty = (sheetName) => sheetName.sheetName !== "";

    const isAllFilledParamNameInput = newParameters.every(isParameterEmpty);
    const isAllFilledSheetName = newParameters.every(isSheetNameEmpty);

    if (
      isAllFilledParamNameInput &&
      isAllFilledSheetName &&
      !hasDuplicates(newParameters)
    ) {
      handleAddParameter(newParameters);
      setOpenModal(false);
      setNewParameters([]);
      setValidation({ isError: false, message: "" });
    } else {
      setValidation({
        ...validation,
        isError: true,
        message: "Check for Sheet names or duplicate parameter names.",
      });
    }
  };

  return (
    <>
      <Buttons
        className="add_new_parameter"
        text={"Add New Parameters"}
        onClick={onClickAddParameterButton}
        size="small"
      />
      {/* Add new parametersData Button */}

      {openModal && (
        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          open={openModal}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Add New Parameters</DialogTitle>
          <DialogContent className="add-new-para-modal">
            <>
              <Grid className="new-para-container" container>
                <Box className="new-para-wrap">
                  <div className="new-para-label">
                    <IconButton
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                      }}
                      onClick={handleClose}
                    >
                      <CloseIcon />
                    </IconButton>
                    {/* <Tooltip title="Max Count 3" arrow> */}
                    <TextField
                      className="input-text"
                      placeholder="No of Parameters"
                      size="small"
                      value={newParameterCount}
                      onChange={(e) =>
                        handleAdNewParameterChange(e.target.value)
                      }
                      type="text"
                    />
                    {/* </Tooltip> */}
                  </div>
                  <Button
                    onClick={(e) => addNewParameterClick()}
                    variant="contained"
                    style={{ paddingLeft: "20px" }}
                  >
                    Add
                  </Button>
                  {/* <IconButton
                    aria-label="toggle password visibility"
                    onClick={(e) => addNewParameterClick()}
                    edge="end"
                    size="large"
                  >
                    <AddCircleOutlineRounded className="plusIcon" />
                  </IconButton> */}
                </Box>
                <FormHelperText>
                  {"Number of parameters to add."}
                </FormHelperText>
                {validation?.isError && (
                  <FormHelperText error variant="outlined">
                    {validation?.message}
                  </FormHelperText>
                )}
              </Grid>
              <br></br>

              {newParameters.length > 0 &&
                newParameters.map((newParameter, newParameterIndex) => (
                  <Grid container className="parameter-add">
                    <Grid item xs={5}>
                      <ParameterNameInput
                        newParameterIndex={newParameterIndex}
                        newParameter={newParameter}
                        handleNewParameterNameChange={
                          handleNewParameterNameChange
                        }
                      />
                    </Grid>

                    <Grid item xs={5}>
                      <FormControl fullWidth>
                        <Select
                          displayEmpty
                          inputProps={{ "aria-label": "Without label" }}
                          // labelId={`select-label-${newParameterIndex}`}
                          value={
                            newParameter?.sheetName
                              ? newParameter?.sheetName
                              : ""
                          }
                          onChange={(e) =>
                            onHandleChangeNewParameterSheetName(
                              e.target.value,
                              newParameterIndex
                            )
                          }
                        >
                          <MenuItem value="">
                            <em>Select output sheet</em>
                          </MenuItem>
                          {sheetNames?.map((item, index) => (
                            <MenuItem key={index} value={item}>
                              {item}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={1}>
                      <IconButton
                        aria-label="delete-parameter"
                        onClick={(e) =>
                          handleDeleteParameter(newParameterIndex)
                        }
                        edge="end"
                      >
                        <DeleteForeverOutlinedIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                ))}
            </>
          </DialogContent>
          <DialogActions>
            <Button
              className="btn-add-para"
              variant="contained"
              onClick={(e) => onClickAddParameter(newParameters)}
              disabled={newParameters.length <= 0}
            >
              Add Parameters
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default NewParameter;
